// Lib
import { connect } from 'react-redux';

// Constants
import { MEASUREMENTS_STORE_NAME } from './measurementsConstants';

export default (...args) => {
    const opts = {
        ...args[3],
        storeKey: MEASUREMENTS_STORE_NAME,
        getDisplayName: (component) => `MeasurementsConnect(${component})`,
    };
    return connect(args[0], args[1], args[2], opts);
};
